import { useState } from 'react'
import { BottomNav, type TabKey } from './components/BottomNav'
import { TodayPage } from './features/today/TodayPage'
import { HistoryPage } from './features/history/HistoryPage'
import { ProgressPage } from './features/progress/ProgressPage'
import { ProfilePage } from './features/profile/ProfilePage'
import { ActiveWorkout } from './features/workout/ActiveWorkout'
import type { WorkoutTemplate } from './domain/types'
import { useStrata } from './data/StrataProvider'
import { Onboarding } from './features/profile/Onboarding'
import { CoachPage } from './features/coach/CoachPage'

export function App() {
  const { state, ready } = useStrata()
  const [tab, setTab] = useState<TabKey>('today')
  const [activeTemplate, setActiveTemplate] = useState<WorkoutTemplate>()

  if (!ready) return <main className="app-loading" aria-label="Cargando Strata"><span>S</span></main>
  if (!state.profile.onboardingComplete) return <Onboarding />

  return (
    <main className="app-shell">
      <div className="page-stage" aria-live="polite">
        {tab === 'today' && <TodayPage onStart={setActiveTemplate} />}
        {tab === 'history' && <HistoryPage />}
        {tab === 'progress' && <ProgressPage />}
        {tab === 'coach' && <CoachPage />}
        {tab === 'profile' && <ProfilePage />}
      </div>
      <BottomNav selected={tab} onSelect={setTab} />
      {activeTemplate && <ActiveWorkout template={activeTemplate} onClose={() => setActiveTemplate(undefined)} />}
    </main>
  )
}
